export default __webpack_public_path__ + "images/feature-blog-pin.png?6d5cce76752a513b5148fa00b6e9282e";